import type { HTMLAttributes } from 'react';
import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { vars, pxToRem } from '$util/theme';

const Styled = styled.strong`
  color: ${vars.quantumverse.reskinColors.purple500};
  font-weight: 700;
  font-size: ${pxToRem(15)};

  &.red {
    color: ${vars.red};
  }
`;

export function TextHighlight({ children, className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <Styled className={classNames('text-highlight', className)} {...props}>
      {children}
    </Styled>
  );
}
TextHighlight.displayName = 'TextHighlight';
